import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.REACT_APP_MY_HOST}/admin`;

class ToolService {

    listTools() {
        return axios.get(`${API_URL}/tools`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    listToolsSimple() {
        return axios.get(`${API_URL}/tools-simple`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    getToolById(toolId) {
        return axios.get(`${API_URL}/tools/${toolId}`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    getThumbnail(toolId) {
        return axios.get(`${API_URL}/tools/${toolId}/thumbnail`, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    updateVariations(id, variationsJson) {
        return axios.put(`${API_URL}/tools/${id}`, variationsJson, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    updateThumbnail(id, formData) {
        console.log('Gửi request update thumbnail cho ID:', id);
        return axios.post(`${API_URL}/tools/${id}/thumbnail`, formData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            console.log('Phản hồi từ API updateThumbnail:', response.data);
            return response.data;
        }).catch(error => {
            console.error('Lỗi khi cập nhật thumbnail:', error.response || error);
            throw error;
        });
    }

    updateDescription(id, description) {
        console.log('Gửi request update description cho ID:', id);
        return axios.put(`${API_URL}/tools/${id}/description`, { description }, {
            headers: authHeader()
        }).then(response => {
            console.log('Phản hồi từ API updateDescription:', response.data);
            return response.data;
        }).catch(error => {
            console.error('Lỗi khi cập nhật mô tả:', error.response || error);
            throw error;
        });
    }

}

export default new ToolService();